import {Fragment} from "vritra";
import css from "./Post.module.css";


export default function Post(props){
    const {title,body}=props;
    const post=Fragment(props);

    post.innateHTML=`
        <text as="h3" class="${css.title}">${title}</text>
        <text class="${css.body}">${body}</text>
    `;
    
    return post;
}